import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmTypeForm from '../../../components/forms/FirearmTypeForm';
import { useCreateFirearmType } from '../../../hooks/useFirearmTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmTypeDTO } from '../../../services/apiClient';

const FirearmTypeCreate: React.FC = () => {
  const createFirearmType = useCreateFirearmType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Types', href: '/admin/firearmtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmTypeDTO) => {
    try {
      await createFirearmType.mutateAsync(data);
      navigate('/admin/firearmtypes');
    } catch (error) {
      console.error('Error creating FirearmType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmType.Edit'
    >
        <FirearmTypeForm
          initialValues={{} as FirearmTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmtypes')}
        />
    </AdminLayout>
  );
};

export default FirearmTypeCreate;